import React from 'react'
import { useState } from 'react'
import { Button, PopoverBody, PopoverHeader, UncontrolledPopover } from 'reactstrap'

export default function SoComment(props) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <Button className='nexogic-btn-link'
                id={props.id}
                type="button" onClick={()=>setIsOpen(!isOpen)}
            >
                <div className="card-text"><span className="icon"><svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5H1M19 1H1M19 9H1M15 13H1" stroke="#3EABCA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg></span><b className='no-colon'>Comment </b>(20)</div>
            </Button>
            <UncontrolledPopover
                isOpen={isOpen}
                placement="bottom"
                target={props.id}
                trigger="click"
                className='nexogic-comment-popover'
            >
                <PopoverBody className='nexogic-popover'>
                    <h3 className="card-title popover-title">Comment <span className='popover-close-btn' onClick={()=>setIsOpen(false)}>&times;</span></h3>
                    <div className="nexogic-floated-input">
                        <textarea type="text" id='so_comment' name='so_comment' className='form-control nexogic-form-control-gray small' placeholder='Write A Comment'></textarea>
                        <button type="button" name="so_comment_submit" id="so_comment_submit" className='btn btn-trans'> <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="23"
                            height="22"
                            fill="none"
                            viewBox="0 0 23 22"
                        >
                            <path
                                stroke="#3EABCA"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M21.252 11.797l-15.538-.738m15.538.738L1.746 20.073l3.968-9.014m15.538.738L2.618 1.709l3.096 9.35"
                            ></path>
                        </svg></button>
                    </div>
                    <div className="nexogic-custom-scroll">
                    
                    <div className="nexogic-comment-lists">
                        <ul>
                            <li>
                                <div className="nexogic-comment-item">
                                    <div className="graphic">
                                        <img src="https://images-dev.nexogic.com/53efb6fd-1ceb-412a-b19d-b65032bde722/a8dd998a-8e20-4ac4-971f-bf91154aa6fc.png" alt="" className='card-img' />
                                    </div>
                                    <div className="info">
                                        <div className="comment-text">
                                            <h3 className="card-title">Steve Jobs <span className='text-muted'>2h ago</span></h3>
                                            <p className='card-text'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum voluptates, earum, dolore architecto odio dolor ipsa saepe possimus, aliquam omnis facere aut praesentium. Labore cupiditate, doloribus reprehenderit placeat nihil doloremque impedit totam est esse explicabo!</p>
                                        </div>
                                        <p className='card-text'><a href="" className="link">Reply</a></p>
                                    </div>
                                </div>
                                <ul>
                                    <li>
                                        <div className="nexogic-comment-item">
                                            <div className="graphic">
                                                <img src="https://images-dev.nexogic.com/53efb6fd-1ceb-412a-b19d-b65032bde722/a8dd998a-8e20-4ac4-971f-bf91154aa6fc.png" alt="" className='card-img' />
                                            </div>
                                            <div className="info">
                                                <div className="comment-text">
                                                    <h3 className="card-title">Steve Jobs <span className='text-muted'>2h ago</span></h3>
                                                    <p className='card-text'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum voluptates, earum, dolore architecto odio dolor ipsa saepe possimus, aliquam omnis facere aut praesentium. Labore cupiditate, doloribus reprehenderit placeat nihil doloremque impedit totam est esse explicabo!</p>
                                                </div>
                                                <p className='card-text'><a href="" className="link">Reply</a></p>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <div className="nexogic-comment-item">
                                    <div className="graphic">
                                        <img src="https://images-dev.nexogic.com/53efb6fd-1ceb-412a-b19d-b65032bde722/a8dd998a-8e20-4ac4-971f-bf91154aa6fc.png" alt="" className='card-img' />
                                    </div>
                                    <div className="info">
                                        <div className="comment-text">
                                            <h3 className="card-title">Steve Jobs <span className='text-muted'>2h ago</span></h3>
                                            <p className='card-text'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum voluptates, earum, dolore architecto odio dolor ipsa saepe possimus, aliquam omnis facere aut praesentium. Labore cupiditate, doloribus reprehenderit placeat nihil doloremque impedit totam est esse explicabo!</p>
                                        </div>
                                        <p className='card-text'><a href="" className="link">Reply</a></p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    </div>
                </PopoverBody>
            </UncontrolledPopover>
        </>

    )
}
